// src/index.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';  
import { appRoutes } from './config/RoutesConfig';
import { App as AntdApp, ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render( 
    <ConfigProvider>
      <AntdApp> {/* ✅ Required for message/notification to work in AntD v5 */}
        <App appRoutes={appRoutes} />
      </AntdApp>
    </ConfigProvider> 
);
